import axios, { AxiosRequestHeaders } from "axios";
import { ApiConfig } from "../services/api-config";

const baseURL = ApiConfig.ROOT_URL + "api/";

const axiosConfig = {
  headers: {
    "Access-Control-Allow-Origin": "*",
  },
};

axios.interceptors.request.use(
  function (config) {
    document.body.classList.add("loading-indicator");
    return config;
  },
  function (error) {
    document.body.classList.remove("loading-indicator");
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    document.body.classList.remove("loading-indicator");
    return response;
  },
  function (error) {
    document.body.classList.remove("loading-indicator");
    return Promise.reject(error);
  }
);

export default class Api {
  static setDefaults() {
    const d = axios.defaults;
    d.baseURL = baseURL;
    this.transformResponse();
  }

  static transformResponse() {
    return {
      transformResponse: [
        (data: any) => {
          return data ? JSON.parse(data) : {};
        },
      ],
    };
  }

  static handleStatus(callback: Function, response: any) {
    const result = response;
    if (response.status !== 200) {
      this.handleException(response, callback);
    } else {
      this.handleResponse(callback, result.data);
    }
  }

  static handleResponse(callback: Function, response: any) {
    callback(response);
  }

  static handleException(ex: any, callback: Function) {
    console.log(ex);
    callback(ex.response?.data);
  }

  static getHeaders(): AxiosRequestHeaders {
    const value = `; ${document.cookie}`;
    const parts = value?.split(`; token=`) ?? [];
    const token =
      parts.length === 2 ? parts.pop()?.split(";").shift() ?? "" : "";

    return {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Credentials": "true",
      "Access-Control-Max-Age": "1800",
      "Access-Control-Allow-Headers": "content-type, Authorization",
      "Access-Control-Allow-Methods": "*",
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `bearer ${token}`,
    };
  }

  static async getForExternalApi(url: string, callback: Function) {
    document.body.classList.add("loading-indicator");
    await axios
      .create()
      .get(url, {})
      .then((response) => {
        this.handleStatus(callback, response);
      })
      .catch((ex) => {
        this.handleException(ex, callback);
      })
      .finally(() => {
        document.body.classList.remove("loading-indicator");
      });
  }

  static async getSilent(api: string, callback: Function, timeout?: number) {
    await axios
      .create()
      .get(baseURL + api, {
        headers: this.getHeaders(),
        timeout,
      })
      .then((response) => {
        this.handleStatus(callback, response);
      })
      .catch((ex) => {
        this.handleException(ex, callback);
      });
  }

  static async get(api: string, callback: Function) {
    await axios
      .get(baseURL + api, {
        headers: this.getHeaders(),
      })
      .then((response) => {
        this.handleStatus(callback, response);
      })
      .catch((ex) => {
        this.handleException(ex, callback);
      });
  }

  static async post(api: string, params: any, callback: Function) {
    await axios
      .post(baseURL + api, params, { headers: this.getHeaders() })
      .then((response) => {
        this.handleStatus(callback, response);
      })
      .catch((ex) => {
        this.handleException(ex, callback);
      });
  }

  static async put(api: string, params: object, callback: Function) {
    await axios
      .put(baseURL + api, params, {
        headers: this.getHeaders(),
      })
      .then((response) => {
        this.handleStatus(callback, response);
      })
      .catch((ex) => {
        this.handleException(ex, callback);
      });
  }

  static async patch(api: string, params: object, callback: Function) {
    await axios
      .patch(baseURL + api, params, {
        headers: this.getHeaders(),
      })
      .then((response) => {
        this.handleStatus(callback, response);
      })
      .catch((ex) => {
        this.handleException(ex, callback);
      });
  }

  static async delete(api: string, callback: Function) {
    await axios
      .delete(baseURL + api, {
        headers: this.getHeaders(),
      })
      .then((response) => {
        this.handleStatus(callback, response);
      })
      .catch((ex) => {
        this.handleException(ex, callback);
      });
  }
}
